<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row class="tes-card pa-7" no-gutters>
    <!--title-->
    <v-col cols="12">
      <h1 class="tes-card__title">Заявление на заключение договора энергоснабжения</h1>
    </v-col>
    <!--steps nav -->
    <template>
      <v-col cols="12" v-if="type !== 'see'">
        <v-row>
          <template v-for="(item, index) in steps">
            <v-col :key="`col-${index}`" :class="(item.step === current ? 'active ' : '') + 'step'">
              <v-row dense>
                <v-col
                  cols="2"
                  class="display-2 pt-3 text-sm-center inner font-weight-bold"
                  v-text="item.step"/>
                <v-col cols="10" class="subtitle-1 inner font-weight-medium" v-html="item.title"/>
              </v-row>
            </v-col>
          </template>
        </v-row>
      </v-col>
      <v-col cols="12">
        <!-- step component -->
        <component
          @transfer="processData"
          @lockFwdBtn="lockFwdBtn"
          :income="steps[current-1].data"
          :formData="formData"
          :is="stepComponent"
          :ref="stepComponent"/>

        <!-- end of step component -->
      </v-col>
      <span v-if="errorMessage" cols="12">{{errorMessage}}</span>

      <v-col cols="12" class="px-5 text-sm-right">
        <p v-if="!editDisable && current !== 6" class="text-sm-left">*- поля обязательные к заполнению</p>
        <v-btn v-if="current > 1" outlined class="mr-5" @click="nav(false)">Назад</v-btn>
        <v-btn
          class="green-button white--text"
          v-if="current < steps.length"
          depressed
          :disabled="nextStepActive"
          @click="nav(true)"
        >Далее
        </v-btn>
        <v-btn
          class="blue-button white--text mr-5"
          v-if="current === steps.length && this.type !== 'see'"
          @click="doSendRequest(true)"
          depressed
        >Сохранить как черновик
        </v-btn>
        <v-btn
          class="green-button white--text"
          v-if="current === steps.length"
          @click="doSendRequest(false)"
          depressed
        >Завершить
        </v-btn>
      </v-col>
      <v-overlay :value="loading">
        <v-progress-circular indeterminate size="64"/>
      </v-overlay>
    </template>
  </v-row>
</template>

<script>
  import {mapState} from "vuex";

  // partial views
  import ContractDetails from "@/components/statements/agreement-conclusion/ContractDetails.vue";
  import IdentificationPage from "@/components/statements/agreement-conclusion/IdentificationPage.vue";
  import AddressPage from "@/components/statements/agreement-conclusion/AddressPage.vue";
  import ObjectDetails from "@/components/statements/agreement-conclusion/ObjectDetails.vue";
  import DocumentsUpload from "@/components/statements/agreement-conclusion/DocumentsUpload.vue";
  import VerificationPage from "@/components/statements/agreement-conclusion/VerificationPage.vue";

  export default {
    layout: "main",
    components: {
      ContractDetails,
      IdentificationPage,
      AddressPage,
      ObjectDetails,
      DocumentsUpload,
      VerificationPage
    },
    data() {
      return {
        current: 1,
        fwdDisabled: false,
        errorMessage: null,
        loading: false,
        // собираем здесь данные для запроса
        formData: {
          userGuid: null,
          filledDate: null,
          isDraft: true
        },
        type: null
      };
    },
    computed: {
      ...mapState({
        steps: state => state.statements.agreementConclusionData,
        editDisable: state => state.statements.editDisable
      }),
      stepComponent() {
        return !!this.steps && this.steps[this.current - 1].component;
      },
      userSettings() {
        return this.$store.getters["account/userSettings"];
      },
      nextStepActive () {
        if (this.editDisable) {
          return false
        } else {
          return this.fwdDisabled
        }
      }
    },
    mounted() {
      if (!this.steps) {
        this.$router.push('/statements/history')
      }
      if(this.$route.query.id){
        this.formData.id = this.$route.query.id
      }
      let {type} = this.$route.query;
      this.type = type;
      if (type === "see") {
        // this.current = 6;
        this.nav();
      } else {
        this.$store.dispatch('statements/setEditDisable', false)
      }

      // console.log(this.$refs[this.stepComponent].transferData())
    },
    methods: {
      lockFwdBtn(doLock = true) {
        this.fwdDisabled = doLock;
      },
      nav(fwd = true) {
        this.$refs[this.stepComponent].transferData();
        fwd ? this.current++ : this.current--;
      },

      doSendRequest(isDraft = true) {
       if (this.type !== 'see')  {
         this.formData.isDraft = isDraft;
         this.formData.userGuid = this.userSettings.userGuid;
         this.loading = true;
         this.formData.typeApplication = "ApplicationForContract"

         this.$store
           .dispatch("statements/" + "saveContractRequest", this.formData)
           .then(response => {
             this.loading = false;
             if (response.data.success) this.$router.push("/");
           })
           .catch(error => {
             this.loading = false;
           });
       } else {
         this.$router.push("/");
       }

      },
      processData(payload) {
        // заполнение шага с подтверждением
        if (this.stepComponent === "verification-page") {
          this.steps.find(
            item => item.component === "verification-page"
          ).data = this.formData;
          return;
        }

        // console.log(payload)

        // let keys = Object.keys(payload);
        //
        // // store steps data
        // keys.forEach(key => {
        //   this.$store.commit("statements/" + "SET_AGREEMENT_CONCLUSION_DATA", {
        //     //index: this.stepComponent,
        //     index: this.current - 1,
        //     key: key,
        //     data: payload[key]
        //   });
        // });

        // fill form data

        switch (this.stepComponent) {

          case "contract-details":
            this.formData.dogovorTp = payload.dogovorTp;
            this.formData.dogovorDate = payload.dogovorDate;
            this.formData.filledDate = payload.filledDate;

            break;

          case "identification-page":
            this.formData.document = {
              series: payload.series,
              number: payload.number,
              issuer: payload.issuer,
              issueDate: payload.issueDate,
              unitCode: payload.unitCode,
              birthDate: payload.birthDate,
              birthPlace: payload.birthPlace,
              inn: payload.inn,
              phone: payload.phone
            };
            break;
          case "object-details":
            this.formData.permittedPower = payload.permittedPower;
            this.formData.resGuid = payload.resGuid;
            this.formData.resName = payload.resName;
            this.formData.totalArea = payload.totalArea;
            this.formData.numberStorey = payload.numberStorey;
            this.formData.floor = payload.floor;
            this.formData.numberRooms = payload.numberRooms;
            this.formData.numberInhabitants = payload.numberInhabitants;
            this.formData.cadastralNumber = payload.cadastralNumber;

            if (!this.formData.addresses) this.formData.addresses = [];

            if (!payload.objectAddress) break;
            let objectAddressExists = this.formData.addresses.find(item => {
              return item.addressType === payload.objectAddress.addressType;
            });

            if (!!objectAddressExists) {
              this.formData.addresses[
                this.formData.addresses.indexOf(objectAddressExists)
                ] = payload.objectAddress;
            } else {
              this.formData.addresses.push(payload.objectAddress);
            }
            ///console.log(this.formData);
            break;

          case "documents-upload":
            this.formData.files = [];
            let fKeys = Object.keys(payload.files);
            fKeys.forEach(i => {
              this.formData.files.push(payload.files[i]);
            });
            break;

          case "address-page":
            this.formData.isEqualRegAddress = payload.isEqualRegAddress;
            if (!this.formData.addresses) this.formData.addresses = [];
            if (!payload.registrationsAddress || !payload.deliveryAddress) break;
            let registrationsAddressExists = this.formData.addresses.find(
              item => {
                return (
                  item.addressType === payload.registrationsAddress.addressType
                );
              }
            );
            if (!!registrationsAddressExists) {
              this.formData.addresses[
                this.formData.addresses.indexOf(registrationsAddressExists)
                ] = payload.registrationsAddress;
            } else {
              this.formData.addresses.push(payload.registrationsAddress);
            }
            let deliveryAddressExists = this.formData.addresses.find(item => {
              return item.addressType === payload.deliveryAddress.addressType;
            });
            if (!!deliveryAddressExists) {
              this.formData.addresses[
                this.formData.addresses.indexOf(deliveryAddressExists)
                ] = payload.deliveryAddress;
              // console.log("deliveryAddressExists");
              // console.log("payload.deliveryAddress", payload);
            } else {
              this.formData.addresses.push(payload.deliveryAddress);
            }
            // console.log("form data after address", this.formData);
            break;
        }
      }
    }
  };
</script>
<style scoped lang="scss">
  $grey: #b3b3b3;

  @mixin tran {
    transition-duration: 0.2s;
    transition-property: color, border-bottom-color;
  }

  h1 {
    @extend %h1;
  }

  .step {
    color: $main-grey;

    div.inner {
      line-height: 20px;
      border-bottom: 4px solid $grey;
      padding-bottom: 15px;
      @include tran;
    }

    &.active {
      @extend %orange-text;

      div.inner {
        border-bottom-color: $main-orange;
        @include tran;
      }
    }
  }
</style>

